import React from 'react'

export default function Navbar() {
  return (
    <>
      <h1>Navbar</h1>
      <p><span className='tag-grey bold'>.navbar</span> class creates a large navbar element that takes the full width of the container </p>
      <p>This class comes with several classes that can be added to elements within the navbar to control their position with ease </p>
    
      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="navbar"&gt;<br/>
          &lt;div class="navbar-header"&gt;header&lt;/div&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;/div&gt;
        </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve'>
      <div className="navbar">
        <div className="navbar-header">header</div>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
        </div>
      </div>

      <h2 className='pt-4'>Navbar Placements</h2>
      <h3>Code:</h3>
      <p> add <span className='tag-grey bold'>.nav-left</span> class to an element inside the navbar to move it to the left of the navbar</p>
      <p> add <span className='tag-grey bold'>.nav-center</span> class to an element inside the navbar to move it to the center of the navbar</p>
      <p> add <span className='tag-grey bold'>.nav-right</span> class to an element inside the navbar to move it to the right of the navbar</p>
      <p>Note: If there are other items that are right beside the element with these added classes, they will also be affected </p>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="navbar"&gt;<br/>
          &lt;div class="navbar-header"&gt;header&lt;/div&gt;<br/>
          &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;li class="nav-center"&gt;link one&lt;/li&gt;<br/>
          &lt;li&gt;link one 2&lt;/li&gt;<br/>
          &lt;li class="nav-right"&gt;link one&lt;/li&gt;<br/>
          &lt;li&gt;link one 2&lt;/li&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
      <div className="navbar">
        <div className="navbar-header">header</div>
            <li>link one</li>
            <li>link one</li>
            <li  className="nav-center">link one</li>
            <li>link one 2</li>
            <li className="nav-right">link one</li>
            <li>link one 2</li>
        </div>
      </div>

      <h2 className='pt-4'>Navbar Right</h2>
      <h3>Code:</h3>
      <p> add <span className='tag-grey bold'>.nav-left</span> class to an element inside the navbar to move it to the left of the navbar</p>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="navbar nav-all-right"&gt;<br/>
          &lt;div class="navbar-header"&gt;header&lt;/div&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h3>Result:</h3>
            <div className='border-grey p-1 border-curve'>
        <div className="navbar nav-all-right">
            <div className="navbar-header">header</div>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
          </div>
      </div>

      <h3>Code:</h3>
      <p> add <span className='tag-grey bold'>.nav-left</span> class to an element inside the navbar to move it to the left of the navbar</p>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="navbar nav-all-right"&gt;<br/>
          &lt;div class="navbar-header nav-left"&gt;header&lt;/div&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <div className="navbar nav-all-right">
            <div className="navbar-header nav-left">header</div>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
          </div>
      </div>

      <h2 className='pt-4'>Navbar Center</h2>
      <h3>Code:</h3>

      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="navbar nav-all-center"&gt;<br/>
          &lt;div class="navbar-header"&gt;header&lt;/div&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <div className="navbar nav-all-center">
            <div className="navbar-header">header</div>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
          </div>
      </div>

      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="navbar nav-all-center"&gt;<br/>
          &lt;div class="navbar-header"&gt;header&lt;/div&gt;<br/>
          &lt;div class="nav-center"&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
              &lt;li&gt;link one&lt;/li&gt;<br/>
          &lt;/ul&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
      <div className="navbar nav-all-center">
        <div className="navbar-header">header</div>
        <div className="nav-center">
            <li>link one</li>
            <li>link one</li>
            <li>link one</li>
            <li>link one 2</li>
            <li>link one 2</li>
        </div>
        </div>
      </div>

      <h2>Collapsible Navbar</h2>
      <p className='italic'>This requires the .js file of this library to function properly</p>
      <p>The data-collapse attribute is compulsory and must match the id of the navbar content </p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;div className="navbar-collapse"&gt;<br />
              &lt;div className="navbar-head"&gt;<br />
                  &lt;div className="navbar-toogle-button" data-collapse="collapseSidebar"&gt;&lt;/div&gt;<br />
                  &lt;div class="navbar-header"&gt;header&lt;/div&gt;<br />
              &lt;/div&gt;<br />
              &lt;div class="navbar" id="collapseSidebar"&gt;<br />
                  &lt;li&gt;link one&lt;/li&gt;<br />
                  &lt;li&gt;link one&lt;/li&gt;<br />
                  &lt;li&gt;link one&lt;/li&gt;<br />
                  &lt;li&gt;link one 2&lt;/li&gt;<br />
                  &lt;li&gt;link one 2&lt;/li&gt;<br />
              &lt;/div&gt;
            &lt;/div&gt;

          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
        <div className="navbar-collapse">
          <div className="navbar-head">
          <div className="navbar-toogle-button" data-collapse="collapseSidebar"></div>
          <div className="navbar-header">header</div>
          </div>
            <div className="navbar" id="collapseSidebar">
                <li>link one</li>
                <li>link one</li>
                <li>link one</li>
                <li>link one 2</li>
                <li>link one 2</li>
            </div>
          </div>
      </div>
    </>
  )
}
